<template>
    <div class="step-box">
        <step
            titleColor="green"
            otherClass="first-step"
        >
            <p slot="title">Step 1</p>
            <p slot="text">Select the animal type</p>
        </step>
        <div class="flex flex-col md:flex-row justify-center items-center px-6 md:px-12 py-4">
            <div
                id="Broiler"
                class="rounded-lg shadow-md hover:shadow-lg border-4 border-transparent flex flex-col items-center bg-white p-4 text-center flex-1 w-full min-w-2xs max-w-xs m-2 md:m-4 "
                :class="selectedAnimal == 'Broiler' ? 'shadow-lg border-4 border-primary' : ' '"
                @click="animalSelected"
            >
                <p class="is-size-4-desktop is-size-6-touch">Meat Poultry</p>
                <img
                    class="h-32 pt-2"
                    src="/images/Broiler Icon.jpg"
                    alt="broiler"
                >
            </div>
            <div
                id="Layer"
                class="rounded-lg shadow-md hover:shadow-lg border-4 border-transparent flex flex-col items-center bg-white p-4 text-center flex-1 w-full min-w-2xs max-w-xs m-2 md:m-4"
                :class="selectedAnimal == 'Layer' ? 'shadow-lg border-4 border-primary' : ' '"
                @click="animalSelected"
            >
                <p class="is-size-4-desktop is-size-6-touch">Egg Poultry</p>
                <img
                    class="h-32 pt-2"
                    src="/images/layer.jpg"
                    alt="layer"
                >
            </div>
            <div
                id="Swine"
                class="rounded-lg shadow-md hover:shadow-lg border-4 border-transparent flex flex-col items-center bg-white p-4 text-center flex-1 w-full min-w-2xs max-w-xs m-2 md:m-4"
                :class="selectedAnimal == 'Swine' ? 'shadow-lg border-4 border-primary' : ' '"
                @click="animalSelected"
            >
                <p class="is-size-4-desktop is-size-6-touch">Swine</p>
                <img
                    class="h-32 pt-2"
                    src="/images/swine-h&s.jpg"
                    alt="swine"
                >
            </div>
            <div
                id="Aqua"
                class="rounded-lg shadow-md hover:shadow-lg border-4 border-transparent flex flex-col items-center bg-white p-4 text-center flex-1 w-full min-w-2xs max-w-xs m-2 md:m-4"
                :class="selectedAnimal == 'Aqua' ? 'shadow-lg border-4 border-primary' : ' '"
                @click="animalSelected"
            >
                <p class="is-size-4-desktop is-size-6-touch">Aqua</p>
                <img
                    class="h-32 pt-2"
                    src="/images/new_aqua.jpg"
                    alt="aqua"
                >
            </div>
        </div>

    </div>
</template>
<script>
export default {
    props: ["productGroup"],
    data() {
        return {
            selectedAnimal: this.productGroup
        };
    },
    methods: {
        animalSelected: function(event) {
            this.selectedAnimal = event.currentTarget.id;
            this.$emit("animalSelected", this.selectedAnimal);
            // event.currentTarget.classList.add("selected");
        }
    }
};
</script>
<style>
.animal-tile {
    min-height: 200px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.first {
    font-size: xx-large;
    min-height: 200px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.second {
    font-size: xx-large;
    max-height: 400px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.third {
    font-size: xx-large;
    max-height: 400px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.iconImage {
    margin-top: 20px;
    height: auto;
    max-width: 100%;
    position: relative;
    width: auto;
}

.selected {
    box-shadow: 0px 0px 0px 7px #22a7f0;
}

#broilerImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/Broiler Icon.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#layerImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/layer.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#swineImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/swine-h&s.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
</style>
